var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh2020 = function SvgRefresh2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "refresh_20_20_svg__a",
    width: 21,
    height: 21,
    x: -1,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M-.11-.241h20v20h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#refresh_20_20_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M9.9 17.828a6.9 6.9 0 0 1-2.762-.557 7.2 7.2 0 0 1-2.247-1.516 7.2 7.2 0 0 1-1.516-2.247 6.9 6.9 0 0 1-.558-2.763q0-1.475.558-2.763a7.2 7.2 0 0 1 1.516-2.247A7.2 7.2 0 0 1 7.138 4.22a6.9 6.9 0 0 1 2.763-.557h.221l-.9-.9a.6.6 0 0 1-.182-.434.633.633 0 0 1 .623-.637q.255-.007.45.179l1.889 1.881a.72.72 0 0 1 .213.528q0 .315-.213.527l-1.874 1.881a.57.57 0 0 1-.441.188.64.64 0 0 1-.45-.2.63.63 0 0 1-.18-.446.6.6 0 0 1 .18-.433l.885-.884h-.221q-2.438 0-4.136 1.698t-1.698 4.135 1.698 4.135q1.697 1.698 4.136 1.698 2.256 0 3.91-1.497t1.89-3.741a.68.68 0 0 1 .219-.424.63.63 0 0 1 .439-.171q.253 0 .44.164a.45.45 0 0 1 .16.405q-.228 2.776-2.249 4.645-2.02 1.87-4.81 1.87"
  }))));
};
export default SvgRefresh2020;